export function formatDateTimeShortAR(value) {
  if (!value) return null;
  try {
    const dt = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(dt.getTime())) return null;

    // dd/mm/aaaa hh:mm (sin segundos), 24h
    return dt.toLocaleString('es-AR', {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });
  } catch {
    return null;
  }
}

export function formatDateTimeShortLabelAR(value, { prefix = 'a las' } = {}) {
  const formatted = formatDateTimeShortAR(value);
  if (!formatted) return null;
  return prefix ? `${prefix} ${formatted}` : formatted;
}

export function formatTimeHMAR(value) {
  if (!value) return null;
  try {
    const dt = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(dt.getTime())) return null;
    return dt.toLocaleTimeString('es-AR', { hour: '2-digit', minute: '2-digit', hour12: false });
  } catch {
    return null;
  }
}

export function formatDateTimeRelativeAR(value, { now = new Date() } = {}) {
  if (!value) return null;
  try {
    const dt = value instanceof Date ? value : new Date(value);
    const current = now instanceof Date ? now : new Date(now);
    if (Number.isNaN(dt.getTime()) || Number.isNaN(current.getTime())) return null;

    const startOfDay = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate());
    const dtDay = startOfDay(dt);
    const nowDay = startOfDay(current);
    const diffDays = Math.round((dtDay.getTime() - nowDay.getTime()) / (24 * 60 * 60 * 1000));

    const hm = formatTimeHMAR(dt);
    if (!hm) return null;

    if (diffDays === 0) return `hoy a las ${hm}`;
    if (diffDays === 1) return `mañana a las ${hm}`;

    const dm = dt.toLocaleDateString('es-AR', { day: '2-digit', month: '2-digit' });
    return `${dm} a las ${hm}`;
  } catch {
    return null;
  }
}
